// extracted by mini-css-extract-plugin
export var closeButton = "_j9-1";
export var closeX = "_j9-3";
export var container = "_j9-0";
export var image = "_j9-2";